module.exports = __webpack_public_path__ + "img/4.d13408c3.webp";